import "../menu/MenuNav.scss";
import { Fragment } from "react";

type GalleryNavProps = {
  selectedCategory: string;
  onSelectCategory: (category: string) => void;
};

const GALLERY_NAV_ITEMS = [
  { key: "3d-carved", label: "3D Carved" },
  { key: "baby-shower", label: "Baby Shower" },
  { key: "birthdays", label: "Birthdays" },
  { key: "bridal", label: "Bridal" },
  { key: "holidays", label: "Holidays" },
  { key: "kids", label: "Kids" },
  { key: "succulents-florals", label: "Succulents & Florals" },
];

function GalleryNav({ selectedCategory, onSelectCategory }: GalleryNavProps) {
  return (
    <nav className="menu-nav">
      {GALLERY_NAV_ITEMS.map((item, index) => (
        <Fragment key={item.key}>
          <button
            type="button"
            className={`${selectedCategory === item.key ? "active" : ""}`}
            onClick={() => onSelectCategory(item.key)}
          >
            {item.label}
          </button>
          {index < GALLERY_NAV_ITEMS.length - 1 && <span className="pipe">|</span>}
        </Fragment>
      ))}
    </nav>
  );
}

export default GalleryNav;
